import React, { memo, useMemo } from "react";
import ReactSVG from "react-svg";
import { withTranslation } from "react-i18next";
import cx from "classnames";

function NotificationHistory(props) {
    const { t, indicator, streamState, onClick = () => {} } = props;

    const format = count => {
        return count < 100 ? count : `##`;
    };

    return (
        <div
            className={cx(`indicator ${streamState}`, { empty: !indicator })}
            title={streamState && t(`notificationHistory.${streamState}`)}
            onClick={onClick}
        >
            <ReactSVG
                title={streamState && t(`notificationHistory.${streamState}`)}
                svgClassName="bell"
                src="/data/svg/notification-bell.svg"
            />
            {indicator > 0 && (
                <span title={streamState && t(`notificationHistory.${streamState}`)} className="label">
                    {format(indicator)}
                </span>
            )}
        </div>
    );
}

export default memo(withTranslation()(NotificationHistory));
